export const root = '/accounting';

export const documents = `${root}/documents`;
export const estimation = `${root}/estimation`;
export const estimationSettings = `${estimation}/settings`;
export const microEstimationFlow = `${estimation}/micro`;

export const exports = `${root}/exports`;
export const exportDetails = `${exports}/:exportId`;

export const newExport = `${exports}/new`;
export const newExportOneOff = `${exports}/new/one-off`;
export const newExportRecurring = `${exports}/new/recurring`;

export const getExportPath = (id: string) => `${exports}/${id}`;

export const getDocumentsPath = (bankAccountId?: string) =>
  bankAccountId ? `${documents}?bankAccountId=${bankAccountId}` : documents;
